import { Link, Text } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetArenaQuery } from "~/graphql/mainHooks";
import { ComplianceExternalObjectType } from "~/graphql/supergraphEnums";
import { ExternalObjectType } from "~/pages/Compliance/types";
import { toGlobalId } from "~/utils/graphql-helpers";
import { generateGpMainUrl } from "~/utils/url";
import { subtitleSeparator } from "../styles_vanilla.css";
import { LinkStyles } from "./styles_vanilla.css";

type Props = {
  arena: ExternalObjectType | null | undefined;
  object: ExternalObjectType | null | undefined;
};

const SubscriptionLink = ({ arena, object }: Props) => {
  const objectId = arena?.objectId ? Number(arena.objectId) : null;
  const isProspect = object?.objectTypeEnum === ComplianceExternalObjectType.Prospect;

  const { data: arenaData } = useGetArenaQuery({
    context: withClientContext("staff"),
    variables: { id: toGlobalId("ArenaObjectType", arena?.objectId || "") },
    skip: !objectId || !isProspect,
  });

  if (!arenaData?.arena?.secondLevelDomain) {
    return null;
  }

  const gpMainUrl = generateGpMainUrl(arenaData?.arena?.secondLevelDomain);

  if (!object?.objectId || !isProspect) {
    return null;
  }

  return (
    <>
      <Text variant="regular-sm" asSpan className={subtitleSeparator}>
        |
      </Text>
      <Link
        className={LinkStyles}
        id="subscriptionsLink"
        href={`${gpMainUrl}/prospect/${object?.objectId}/subscription`}
        shouldOpenInNewTab
        icon="external-link"
        iconPosition="right"
        variant="primary"
      >
        Subscription
      </Link>
    </>
  );
};

export default SubscriptionLink;
